// Import Types
import type { Award, DataWithPaging } from 'types';
// Import Configs
import { CRMRequestService, postCancelableRequest } from './http.config';

const AwardHttpService = {
    getAwardsList: () => {
        return postCancelableRequest<DataWithPaging<Award>>({
            requestService: CRMRequestService,
            endpointPath: () => '/Awarding/List',
        });
    },

    createAward: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/Awarding/Create',
        });
    },

    editAward: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/Awarding/Update',
        });
    },
};
export default AwardHttpService;
